import { ResourceCentrePageCategoryItem } from '../../../types';

export const translations: ResourceCentrePageCategoryItem = {
  title: 'Driver\'s Licence',
  content: [
    'Your driver&#39;s licence  is an important piece of documentation that is required to operate a motor vehicle and is',
    'often used as a verification of your identity. Follow the steps below to get a replacement if your driver&#39;s',
    'licence  has been lost or stolen:',

    '<h6>British Columbia</h6>',
    '<ul>',
    '<li>Enhanced Driver&#39;s licence  (with photo): Call the EDL Customer line immediately at',
    '<a  href="tel:+1-866-972-6888">1-866-972-6888</a>. You will need to book an in-person appointment to replace the',
    'card, and bring your birth certificate/citizen document and one other piece of acceptable identification. Contact the',
    'EDL Customer line to ensure you have proper identification before your visit.</li>',
    '<li>Regular Driver&#39;s licence : you will need to visit a driver licensing office with identification and pay for a',
    'new card and the upgrade to the enhanced identification.</li>',
    '</ul>',

    '<h6>Alberta</h6>',
    '<ul>',
    '<li>Immediately apply for a free replacement at your nearest registry agent. You will need to provide valid identification.</li>',
    '<li>Contact the police and obtain a police report. You will receive a police case report number that will be recorded',
    'with Alberta registries.</li>',
    '</ul>',

    '<h6>Saskatchewan</h6>',
    '<ul>',
    '<li>Get a replacement for a small fee by visiting a motor licence  issuer if you are replacing your existing photo.</li>',
    '<li>If you are keeping your existing photo you can either visit a motor licence  issuer or apply online at the MySGI website.</li>',
    '</ul>',

    '<h6>Manitoba</h6>',
    '<ul>',
    '<li>Report a lost or stolen licence  at <a  href="tel:+1-866-323-0544">1-866-323-0544</a>.</li>',
    '<li>Replace it as soon as possible at your nearest Autopac or Service Centre.</li>',
    '<li>You will need to have your photo taken and provide another form of identification (e.g., birth certificate,',
    'vehicle registration card, Manitoba Health card, citizenship card or passport).</li>',
    '<li>A small fee must be paid at the time of replacement.</li>',
    '<li>Keep the temporary paper licence , that will be issued to you the same day, until your permanent card arrives.</li>',
    '</ul>',

    '<h6>Ontario</h6>',
    '<ul>',
    '<li>Immediately request a replacement at a ServiceOntario location for a small fee. Bring personal',
    'identification documents that verify your name, date of birth and signature.</li>',
    '<li>If you are outside of Ontario at the time of loss or theft, you can get a temporary licence  mailed to you',
    'assuming your driver&#39;s licence  is not cancelled or suspended. This temporary licence  is only valid for a fixed',
    'period of time so you must visit a ServiceOntario centre upon your return to Ontario in order to replace it with',
    'a new permanent driver&#39;s licence .</li>',
    '<li>If you will be outside of Ontario for 6+ months, you should call ServiceOntario at',
    '<a  href="tel:416-235-2999">416-235-2999</a> to find out about eligibility and what the requirements are to get a',
    'replacement licence .</li>',
    '</ul>',

    '<h6>Quebec</h6>',
    '<ul>',
    '<li>Visit a Société de l&#39;assurance automobile du Québec (SAAQ) service outlet with valid government',
    'identification, such as Canadian passport, Canadian Citizenship Certificate with photo, valid Quebec Health',
    'Insurance Card with photo, Foreign passport along with proof of known legal presence in Canada, Permanent Resident',
    'Card, Canadian Armed Forces identity card, Certificate of Indian Status. A small fee applies.</li>',
    '<li>If you are outside of Quebec at the time of loss or theft, you can mail or fax a request and a driver&#39;s',
    'licence  with no photo or signature will be sent to you. Following your return to Québec, you will have to go to',
    'a service outlet to get a licence  with a photo and signature.</li>',
    '</ul>',

    '<h6>Newfoundland</h6>',
    '<ul>',
    '<li>Apply in person, or by mail/fax, to the nearest Motor Registration Division office. Provide your driver&#39;s',
    'licence number if you know it. If not, provide your name, address, and date of birth. A small fee applies.</li>',
    '</ul>',

    '<h6>New Brunswick</h6>',
    '<ul>',
    '<li>Request for a replacement at a Service New Brunswick office.</li>',
    '<li>You must submit:',
    '<ul>',
    '<li>At least one document from the Acceptable Identification documents list (List 1)</li>',
    '<li>At least two documents from the list of Acceptable Proof of New Brunswick Residency documents (List 2)</li>',
    '<li>Proof of name change if applicable (i.e. marriage certificate, divorce papers, or Certificate of Name Change).</li>',
    '</ul>',
    '</li>',
    '</ul>',

    '<h6>Nova Scotia</h6>',
    '<ul>',
    '<li>Apply for a replacement at a Registry of Motor Vehicles office for a small fee. You have to submit Form 1 and',
    'Specific identification may be required.</li>',
    '</ul>',

    '<h6>PEI</h6>',
    '<ul>',
    '<li>If you lose your driver&#39;s licence , you can request a duplicate copy at Access PEI in person. A small fee',
    'applies. Proper forms must be filled out.</li>',
    '<li>If you are out of the Province, call <a  href="tel:902-838-0600">902-838-0600</a> or email at',
    '<a href="mailto:swat@gov.pe.ca">swat@gov.pe.ca</a> for assistance.</li>',
    '</ul>',

    '<h6>Northwest Territories</h6>',
    '<ul>',
    '<li>Request a new card online as soon as possible. Alternatively, you may visit your local Driver and Vehicle Licensing Office.</li>',
    '<li>If you are outside the Province, you can contact the Road Licensing and Safety Division of the Department of',
    'Transportation for a Confirmation Letter (this can be used until you are back in the NWT for your replacement).',
    'You can send a letter requesting your Confirmation Letter along with a piece of photo identification either by',
    'fax to <a  href="tel:1-867-873-0120">1-867-873-0120</a> or by email at',
    '<a  href="mailto:dvlicensing@gov.nt.ca">dvlicensing@gov.nt.ca</a>.</li>',
    '</ul>',

    '<h6>Nunavut</h6>',
    '<ul>',
    '<li>In Iqaluit, Rankin Inlet, Cambridge Bay and Gjoa Haven, you can get a replacement at a Motor Vehicles Division',
    'issuing office. These offices can be reached toll-free at <a href="tel:+1-888-975-5999">1-888-975-5999</a>.</li>',
    '<li>In other communities, you can apply at the office of the local Municipal Liaison Officer (MLO) or Government',
    'Liaison Officer (GLO).</li>',
    '<li>A small fee will apply.</li>',
    '<li>You have to show two government issued identification, at least one showing your date of birth.</li>',
    '</ul>',

    '<h6>Yukon</h6>',
    '<ul>',
    '<li>Notify the police that you have lost your driver&#39;s licence .</li>',
    '<li>Apply for a replacement driving licence  at a Yukon Motor Vehicles office by paying a small fee.</li>',
    '<li>A temporary driving licence  will be issued to you until you receive the new licence  by mail.</li>',
    '<li>You need to carry original documentation that includes your:',
    '<ul>',
    '<li>Full legal name;</li>',
    '<li>Date of birth;</li>',
    '<li>Legal presence in Canada; and</li>',
    '<li>Photo and signature</li>',
    '</ul>',
    '</li>',
    '</ul>'
  ].join('\n')
};
